export default __webpack_public_path__ + "static/media/checkbox-interment.965e1e90.svg";